import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Button } from 'antd';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { FormBlock } from '@/components/FormBlock';
import { useWindowHeight } from '@/hooks/useWindowHeight';
import { useWindowWidth } from '@/hooks/useWindowWidth';
import { useZustandSync } from '@/hooks/useZustandSync';
import { productStore } from '@/stores/productStore';

import Checkbox from '../form/Checkbox';
import { ErrorMessage } from '../form/ErrorMessage';
import { Modrawer } from '../Modrawer';

const producerUseTermsSchema = z.object({
  producerUseTerm: z.boolean().refine(val => val === true, {
    message: 'Você deve aceitar os termos de uso para continuar'
  })
});

type ProducerUseTermsFormValues = z.infer<typeof producerUseTermsSchema>;

const breakpoint = 768;

export default function UseTerm() {
  const [openModal, setOpenModal] = useState(false);

  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();

  const modalWidth = windowWidth * 0.8;
  const iframeHeight = windowWidth > breakpoint ? Math.floor(windowHeight * 0.6) : '100%';

  const form = useForm<ProducerUseTermsFormValues>({
    resolver: zodResolver(producerUseTermsSchema),
    mode: 'onChange',
    defaultValues: { producerUseTerm: productStore.getState().producer.useTerm ?? false }
  });

  useZustandSync<ProducerUseTermsFormValues>(form.control, (data, current) => ({
    producer: {
      ...(current.producer || {}),
      useTerm: data.producerUseTerm
    }
  }));

  const modalAgree = () => {
    form.setValue('producerUseTerm', true);
    setOpenModal(false);
  };

  return (
    <FormBlock name='producer-use-term' form={form} title='Termos de uso'>
      <Checkbox id='producerUseTerm' name='producerUseTerm'>
        Aceito os{' '}
        <a id='useTermsLink' target='_blank' rel='noreferrer' onClick={() => setOpenModal(true)}>
          termos de uso
        </a>
      </Checkbox>
      <Modrawer
        open={openModal}
        full
        width={modalWidth}
        height={modalWidth}
        breakpoint={breakpoint}
        onCancel={() => setOpenModal(false)}
        title={'Termos de Uso'}
        footer={
          <div className='flex w-full justify-center'>
            <Button id='agree' className='override-button-base! w-full!' type='primary' onClick={modalAgree}>
              Entendi e Concordo
            </Button>
          </div>
        }
      >
        <iframe className='w-full border-0' style={{ height: iframeHeight }} src='https://www.eduzz.com/termos' />
      </Modrawer>
      <ErrorMessage fieldName='producerUseTerm' />
    </FormBlock>
  );
}
